import request from '@/utils/request'
import { formatParam } from '@/utils/tool'

// 全局获取sizeAll
export const getAllSizeRequest = async (url, params) => {
  const [res1, res2] = await Promise.all([
    await request(`${url}?${formatParam(params)}`, {
      method: 'GET'
    }),
    await request(`${url}?${formatParam(params)}&isForCount=true&autoCount=true`, {
      method: 'GET'
    })
  ])
  console.log(res1, res2, 1111)
  const { sizeAll, pageCount, data } = res2
  res1.sizeAll = (sizeAll || sizeAll === 0) ? sizeAll : data.sizeAll
  res1.pageCount = pageCount
  return res1
}

// 直播列表
export function getLivePlanList (params?: {
  title: string,
}): any {
  return getAllSizeRequest('/saas/plan/info/list', params)
}

// 加载直播计划详情
export function getLoad (id): any {
  return request(`/saas/plan/info/load?id=${id}`, {
    method: 'GET'
  })
}

// 直播报名
export function enrol (params, planId): any {
  return request(`/saas/plan/info/enrol?planId=${planId}`, {
    method: 'POST',
    data: params
  })
}

// 取消报名
export function cancelEnrol (id): any {
  return request(`/saas/plan/info/cancelEnrol?planId=${id}`, {
    method: 'PUT'
  })
}

// 获取报名商品列表
export function getlistSaasProduct (params): any {
  return getAllSizeRequest('/saas/plan/info/listSaasProduct', params)
}
